<template>
  <div>
    <div class="modal fade" id="staticMainDebtorBackdrop" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1"
         aria-labelledby="staticMainDebtorBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="staticMainDebtorBackdropLabel">Make wallet Request</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeMainDebtorDialog"
                    aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleSubmit2">
              <div class="mb-2">
                <label for="amount" class="fw-bold">Amount</label>
                <input type="number" placeholder="Amount" class="form-control" id="amount" v-model="form2.amount">
              </div>
              <div class="mb-2">
                <label for="amount" class="fw-bold">select wallet</label>
                <select v-model="sendWallet" class="form-select">
                  <option value="" disabled>Select Wallet</option>
                  <option v-for="(wallet, n) in otherWallets" :key="n+1" :value="wallet.id">
                    {{ wallet.wallet_name }}
                  </option>
                </select>
              </div>
              <div class="mb-2">
                <label for="expense" class="fw-bold">Reason</label>
                <textarea rows="3" placeholder="Like Daily Request....." class="form-control" id="expense"
                          v-model="form2.reason">

                </textarea>
              </div>

              <div class="row mt-2 d-flex justify-content-center">
                <button class="btn btn-primary w-50 h-100" type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <floating-add-button data-bs-toggle="modal" data-bs-target="#staticMainDebtorBackdrop"/>
  </div>
</template>
<script>
import FloatingAddButton from "@/components/layout/utils/FloatingAddButton.vue"
import {v4 as uuidv4} from "uuid";
import {Storage} from "@/Services/Storage";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: 'MakeWalletRequest',
  components: {FloatingAddButton},
  beforeMount() {
    this.getLoggedInUser()
  },
  computed:{
    otherWallets(){
      // GINGER-20260710-WALLET-NULL-GUARD: Defensive against malformed wallet
      // entries (null wallet object OR null wallet.id) and against a missing
      // selectedWallet. Prevents TypeError "Cannot read properties of null
      // (reading 'id')" that fired in Dashboard.vue:628 → MakeWalletRequest.vue:61
      // when /get-all-wallets returned an entry with null id. Skips bad entries
      // silently — better UX than crashing the screen mid-render.
      if (!this.wallets) return []
      if (!this.selectedWallet || this.selectedWallet.id == null) return [...this.wallets]
      return this.wallets.filter(wallet =>
        wallet && wallet.id != null && wallet.id !== this.selectedWallet.id
      )
    }
  },
  props: {
    wallets: {},
    selectedWallet : {}
  },
  data() {
    return {
      form2: {},
      sendWallet : ``,
      formData: {},
      user: {
        Username: 'Null',
        id: 'Null',
        office: ''
      },
      status: 'APPROVED',
      uuid: uuidv4()  // Generate UUID and store it in a data property

    };
  },
  methods: {
    async getLoggedInUser() {
      try {
        this.user = await Storage.getCurrentUser();
        console.log('Logged-in user:', this.user);  // Add logging to verify user data
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },

    async handleSubmit2() {
      // Collect form data and selected wallet

      const requestData = {
        localId: generateUUID(),  // Include UUID in request data
        requestBy: this.user.username,
        amount: this.form2.amount,
        reason: this.form2.reason,
        fromWallet: this.sendWallet,
        toWallet: this.selectedWallet
      };

      try {
        // Show loading indicator
        this.$utils.showLoading();

        // Submit data to the server
        await axios.post(ticketApi2 + 'transaction-handler/wallet-request', requestData);
        Swal.fire({
          title: 'Success!',
          text: 'Request approved successfully.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
        // Handle success
        console.log('Request submitted successfully');
        this.form2.amount = '';
        this.form2.reason = '';
        this.selectedWallet = '';
       } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        // Hide loading indicator
        this.$utils.hideLoading();
      }
    },
  }
}
</script>
<style scoped lang="scss">

#vgt-table td {
  text-align: center !important;
}

</style>